import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a user clicks on the upsell from the depleted state',
  name: 'depleted_upsell_clicked',
  params: [
    {
      description: 'The surface where the upsell was clicked',
      name: 'surface',
      required: true,
      type: 'enum',
      values: ['upload_modal', 'canvas', 'banner', 'canvas_agent_chat'],
    },
    {
      description: 'Number of days since the billing cycle started',
      name: 'days_since_cycle_start',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
